import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../../assests/logoWhite.png';
import './Footer.css';
export default function Footer() {
  const { t, i18n } = useTranslation();
  const en = i18n.language.startsWith('en');
  return <footer className="footer-section">
    <div className="footer-container">
      <div className="footer-intro"><Link to="/"><img src={Logo} width="160" height="90" loading="lazy" alt="THAS Multitech AB" /></Link><p>{en ? 'From concept to creation.' : 'Från koncept till verklighet.'}</p></div>
      <div><h2>{en ? 'Explore' : 'Utforska'}</h2><nav className="footer-links" aria-label={en ? 'Footer navigation' : 'Sidfotsmeny'}><Link to="/#services">{t('Services')}</Link><Link to="/3d-printing">{en ? '3D printing' : '3D-utskrift'}</Link><Link to="/#about">{t('About us')}</Link><Link to="/blogg">{t('Blogs')}</Link></nav></div>
      <div className="footer-contact"><h2>{en ? 'Tell us about your idea' : 'Låt oss prata om din idé'}</h2><p>Stockholm, {en ? 'Sweden' : 'Sverige'}</p><a href="mailto:info@thas-multitech.com">info@thas-multitech.com</a><a href="tel:+46760211685">+46 76 021 16 85</a><Link to="/#contact">{en ? 'Request a quote' : 'Be om en offert'} ↗</Link></div>
    </div>
    <div className="footer-bottom">© {new Date().getFullYear()} THAS Multitech AB · {en ? 'All rights reserved.' : 'Alla rättigheter förbehållna.'}</div>
  </footer>;
}
